import { render, staticRenderFns } from "./SocialFooter.vue?vue&type=template&id=577cc355&"
import script from "./SocialFooter.vue?vue&type=script&lang=js&"
export * from "./SocialFooter.vue?vue&type=script&lang=js&"
import style0 from "./SocialFooter.vue?vue&type=style&index=0&id=577cc355&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports